import { Link, TopHat, Typography, palette } from "@callcenter/design-system"
import { t } from "i18next"
import { useUnit } from "effector-react"
import { $userService } from "@callcenter/effector-services"

import styles from "./styles.module.pcss"

export const TermsOfService = () => {
  const isShowTosNotification = useUnit($userService.$userSettings).show_tos_notification

  if (!isShowTosNotification) {
    return null
  }

  return (
    <TopHat type="info">
      <div className={styles.container}>
        <Typography.Body2 color={palette.gray1}>
          {t("component_commonKeys_termsOfService_topHat_topHatLabel")}
        </Typography.Body2>
        <Link href="/tos_consent" className={styles.link}>
          {t("component_commonKeys_termsOfService_topHat_reviewAndAcceptLabel")}
        </Link>
      </div>
    </TopHat>
  )
}
